import type { ApiDifficulty } from '@/api/types';
import type { LocalizedText } from '@/types';

/** Qiyinlik sahifalari: /problems/difficulty/{easy|medium|hard} */
export interface DifficultyMeta {
  api: ApiDifficulty;
  /** URL segmenti */
  level: 'easy' | 'medium' | 'hard';
  title: LocalizedText;
  desc: LocalizedText;
}

export const DIFFICULTIES: DifficultyMeta[] = [
  {
    api: 'EASY',
    level: 'easy',
    title: { uz: 'Oson SQL masalalar', ru: 'Лёгкие задачи по SQL', en: 'Easy SQL problems' },
    desc: {
      uz: "Boshlovchilar uchun oson SQL masalalar: SELECT, WHERE, ORDER BY va oddiy JOIN'lar. Real jadvallar ustida yeching va onlayn tekshiring.",
      ru: 'Лёгкие задачи по SQL для начинающих: SELECT, WHERE, ORDER BY и простые JOIN.',
      en: 'Easy SQL problems for beginners: SELECT, WHERE, ORDER BY and simple JOINs.',
    },
  },
  {
    api: 'MEDIUM',
    level: 'medium',
    title: { uz: "O'rta darajadagi SQL masalalar", ru: 'Задачи по SQL среднего уровня', en: 'Medium SQL problems' },
    desc: {
      uz: "O'rta darajadagi SQL masalalar: agregatsiya, GROUP BY, subquery va window funksiyalar. Intervyuga tayyorlanish uchun.",
      ru: 'Задачи по SQL среднего уровня: агрегация, GROUP BY, подзапросы и оконные функции.',
      en: 'Medium SQL problems: aggregation, GROUP BY, subqueries and window functions.',
    },
  },
  {
    api: 'HARD',
    level: 'hard',
    title: { uz: 'Qiyin SQL masalalar', ru: 'Сложные задачи по SQL', en: 'Hard SQL problems' },
    desc: {
      uz: "Qiyin SQL masalalar: rekursiv CTE, murakkab window funksiyalar va so'rov optimizatsiyasi. Tajribali dasturchilar uchun.",
      ru: 'Сложные задачи по SQL: рекурсивные CTE, сложные оконные функции и оптимизация запросов.',
      en: 'Hard SQL problems: recursive CTEs, advanced window functions and query optimization.',
    },
  },
];

export const difficultyPath = (api: ApiDifficulty): string => `/problems/difficulty/${api.toLowerCase()}`;

export const difficultyFromParam = (param: string | undefined): DifficultyMeta | undefined =>
  DIFFICULTIES.find((d) => d.level === param);
